"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EBillingsSource = exports.EBillingsStatus = void 0;
var EBillingsStatus;
(function (EBillingsStatus) {
    EBillingsStatus["pending"] = "pending";
    EBillingsStatus["refunded"] = "refunded";
    EBillingsStatus["complete"] = "complete";
    EBillingsStatus["invalid"] = "invalid";
})(EBillingsStatus || (exports.EBillingsStatus = EBillingsStatus = {}));
var EBillingsSource;
(function (EBillingsSource) {
    EBillingsSource['sendings.sms'] = "sendings.sms";
    EBillingsSource['sendings.push'] = "sendings.push";
    EBillingsSource['sendings.viber'] = "sendings.viber";
    EBillingsSource['sendings.voice'] = "sendings.voice";
    EBillingsSource['sendings.whatsapp'] = "sendings.whatsapp";
    EBillingsSource['sendings.vk'] = "sendings.vk";
    EBillingsSource['sendings.ok'] = "sendings.ok";
    EBillingsSource['sendings.whatsappchat'] = "sendings.whatsappchat";
    EBillingsSource['sendings.viberchat'] = "sendings.viberchat";
    EBillingsSource['sendings.vkchat'] = "sendings.vkchat";
    EBillingsSource['sendings.telegramchat'] = "sendings.telegramchat";
    EBillingsSource['sendings.facebookchat'] = "sendings.facebookchat";
    EBillingsSource['sendings.flashcall'] = "sendings.flashcall";
    EBillingsSource["hlr"] = "hlr";
    EBillingsSource['subscription.apisender'] = "subscription.apisender";
    EBillingsSource["accrual"] = "accrual";
    EBillingsSource["subtract"] = "subtract";
})(EBillingsSource || (exports.EBillingsSource = EBillingsSource = {}));
//# sourceMappingURL=billings.enum.js.map